var Backbone = require('backbone'),
    GraphicStamps = require('./graphicStamps'),
    TextStamps = require('./textStamps'),
    fvChannel = require('glRadio').channel('FV');


module.exports = Backbone.Model.extend({

    /* -- don't need and not set but commented out for clarity of response
    defaults: {
        graphicStamps: [],
        textStamps: []
    },
    */

    constructor: function() {

        this.graphicStamps = new GraphicStamps();
        this.textStamps = new TextStamps();

        Backbone.Model.apply( this, arguments );

    },

    url: function() {
        return fvChannel.request('apiUrl').myStamps;
    },

    parse: function( data ) {

        this.graphicStamps.reset( data.graphicStamps,  { parse: true } );
        this.textStamps.reset( data.textStamps, { parse: true } );

        return;

    },

    getGraphicStamps: function() {
        return this.graphicStamps;
    },

    getTextStamps: function() {
        return this.textStamps;
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/user/stamps/myStamps.js
 ** module id = 90
 ** module chunks = 0
 **/